export default "__VITE_ASSET__DTCGKGfb__"